<aaron-opener-info (toggled)="showWords=$event"></aaron-opener-info>
<aaron-special-text [showWords]="showWords"></aaron-special-text>
<aaron-dev-projects></aaron-dev-projects>
<div class="flex-fill"></div>
<aaron-social-links></aaron-social-links>
